import Element from '../utils/element';

export default function () {

	return Element('category-count--prds');

};
